import React from 'react';
import classNames from "classnames";
import { FormControl, InputLabel, Input } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

import styles from "../../../assets/jss/imperial-input-style";
const useStyles = makeStyles(styles);

const ImperialTextField = (props) => {

  const classes = useStyles();
  const {
    id,
    value,
    onChange,
    labelText,
    white,
    error,
    success,
    formControlProps,
    inputRootCustomClasses,
    autoComplete,
    name
  } = props

  const labelClasses = classNames({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error
  });

  const underlineClasses = classNames({
    [classes.underlineError]: error,
    [classes.underlineSuccess]: success && !error,
    [classes.underline]: true,
    [classes.whiteUnderline]: white
  });

  const marginTop = classNames({
    [inputRootCustomClasses]: inputRootCustomClasses !== undefined
  });

  const inputClasses = classNames({
    [classes.input]: true,
    [classes.whiteInput]: white
  });

  var formControlClasses;

  if (formControlProps !== undefined) {
    formControlClasses = classNames(
      formControlProps.className,
      classes.formControl
    );
  } else {
    formControlClasses = classes.formControl;
  }

  return (
    <FormControl {...formControlProps} className={formControlClasses} variant="standard">
      {labelText !== undefined ? (
        <InputLabel
          htmlFor={id}
            className={classes.labelRoot + " " + labelClasses}
        >
          {labelText}
        </InputLabel>
      ) : null}
      <Input
        id={id}
        autoComplete={autoComplete}
        label={labelText}
        value={value}
        onChange={onChange}
        name={name}
        classes={{
          input: inputClasses,
          root: marginTop,
          disabled: classes.disabled,
          underline: underlineClasses
        }}
      />
    </FormControl>
  );
};

ImperialTextField.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  white: PropTypes.bool,
  autoComplete: PropTypes.string
};

export default ImperialTextField;